// @flow
import React from 'react'
require('./styles.scss')

// let intro = require('./cover-desktop.mp4')
// let introMobile = require('./cover-mobile.mp4')
// let introWebM = require('./cover-desktop.webm')
// let introWebMmobile = require('./cover-mobile.webm')
let poster = require('./teaser.jpg?sizes=300w+600w+900w+1200w+1800w+2400w&placeholder')
// let coverImage = require('./teaser-dark.png')
let coverImage = require('./teaser-dark.png?sizes=300w+600w+900w+1200w+1800w+2400w&placeholder')

export function cover (props: { title: string, subtitle: string }) {
  // const isMobile = window.innerWidth < 800
  // const isIOS9 = true // /iPhone OS [6789]_/.test(navigator.userAgent)
  // if (isMobile) {
  //   poster = require('./teaser.jpg?sizes=300w+600w+900w+1200w+1800w+2400w&placeholder')
  // }
  let placeholderColor = poster.placeholder.color
  return (
    <div
      className='cover'
      style={{
        backgroundColor: `rgba(${placeholderColor.join(', ')})`
      }}
    >
      {/* {!isIOS9 && (
        <video
          autoPlay
          muted
          playsInline
          preload
          loop
          poster={poster.placeholder.url}
          ref={(video) => {
            if (video) {
              video.setAttribute('playsinline', '')
            }
          }}
        >
          {!isMobile && <source src={introWebM} type='video/webm' />}
          {isMobile && <source src={introWebMmobile} type='video/webm' />}
          {!isMobile && <source src={intro} type='video/mp4' />}
          {isMobile && <source src={introMobile} type='video/mp4' />}
        </video>
      )} */}
      {/* {isIOS9 && <img src={poster} alt='' className='fallback' />} */}
      {/* <img src={coverImage} alt='' className='fallback' /> */}
      <img
        srcSet={`
      ${coverImage.sources['300w']} 300w,
      ${coverImage.sources['600w']} 600w,
      ${coverImage.sources['900w']} 900w,
      ${coverImage.sources['1200w']} 1200w,
      ${coverImage.sources['1800w']} 1800w,
      ${coverImage.sources['2400w']} 2400w
      `}
        src={coverImage.sources['1800w']}
        alt=''
        className='fallback'
      />
      <div className='top gradient' />
      <div
        className='ui mobile only'
        style={{
          position: 'absolute',
          bottom: '0',
          left: 0,
          width: '100vw'
        }}
      >
        <div className='ui container'>
          <div className=''>
            <h1
              className='ui inverted left aligned header'
              style={{
                textAlign: 'left'
              }}
            >
              {props.title}
            </h1>
            <div className='sub header'>{props.subtitle}</div>
          </div>
        </div>
      </div>
      <div
        className='mobile hidden'
        style={{
          position: 'absolute',
          bottom: '1em',
          left: 0,
          width: '100vw'
        }}
      >
        <div className='ui left aligned container'>
          <div className=''>
            <h1 className='ui inverted header' style={{}}>
              {props.title}
              <div className='sub header'>{props.subtitle}</div>
            </h1>
          </div>
        </div>
      </div>
    </div>
  )
}

export default cover



// WEBPACK FOOTER //
// ./src/components/cover/index.js